/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Target
 */
export interface Target {
  /**
   *
   * @type {number | null}
   * @memberof Target
   */
  companyId?: number | null;
  /**
   *
   * @type {number}
   * @memberof Target
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Target
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string | null}
   * @memberof Target
   */
  dutyStatusReason?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Target
   */
  emails?: Array<any>;
  /**
   *
   * @type {object}
   * @memberof Target
   */
  groupDetails?: object;
  /**
   *
   * @type {Array<any>}
   * @memberof Target
   */
  groupIds?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof Target
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Target
   */
  imageUrl: string;
  /**
   *
   * @type {string}
   * @memberof Target
   */
  key: string;
  /**
   *
   * @type {number | null}
   * @memberof Target
   */
  maxWrapUpSeconds?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof Target
   */
  name?: string | null;
  /**
   *
   * @type {number | null}
   * @memberof Target
   */
  officeId?: number | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Target
   */
  onDutyGroupIds?: Array<any>;
  /**
   *
   * @type {string | null}
   * @memberof Target
   */
  onDutyStatus?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Target
   */
  phones?: Array<any>;
  /**
   *
   * @type {number | null}
   * @memberof Target
   */
  ringSeconds?: number | null;
  /**
   *
   * @type {string}
   * @memberof Target
   */
  targetId?: string;
  /**
   *
   * @type {string}
   * @memberof Target
   */
  targetType?: TargetTargetTypeEnum;
  /**
   *
   * @type {string | null}
   * @memberof Target
   */
  timezone?: string | null;
}

/**
 * @export
 */
export const TargetTargetTypeEnum = {
  User: 'user',
  Room: 'room',
  Callcenter: 'callcenter',
  Department: 'department',
  Office: 'office',
  Company: 'company',
} as const;
export type TargetTargetTypeEnum =
  (typeof TargetTargetTypeEnum)[keyof typeof TargetTargetTypeEnum];

/**
 * Check if a given object implements the Target interface.
 */
export function instanceOfTarget(value: object): value is Target {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function TargetFromJSON(json: any): Target {
  return TargetFromJSONTyped(json, false);
}

export function TargetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Target {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'] == null ? undefined : json['company_id'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    dutyStatusReason:
      json['duty_status_reason'] == null
        ? undefined
        : json['duty_status_reason'],
    emails: json['emails'] == null ? undefined : json['emails'],
    groupDetails:
      json['group_details'] == null ? undefined : json['group_details'],
    groupIds: json['group_ids'] == null ? undefined : json['group_ids'],
    id: json['id'],
    imageUrl: json['image_url'],
    key: json['key'],
    maxWrapUpSeconds:
      json['max_wrap_up_seconds'] == null
        ? undefined
        : json['max_wrap_up_seconds'],
    name: json['name'] == null ? undefined : json['name'],
    officeId: json['office_id'] == null ? undefined : json['office_id'],
    onDutyGroupIds:
      json['on_duty_group_ids'] == null ? undefined : json['on_duty_group_ids'],
    onDutyStatus:
      json['on_duty_status'] == null ? undefined : json['on_duty_status'],
    phones: json['phones'] == null ? undefined : json['phones'],
    ringSeconds:
      json['ring_seconds'] == null ? undefined : json['ring_seconds'],
    targetId: json['target_id'] == null ? undefined : json['target_id'],
    targetType: json['target_type'] == null ? undefined : json['target_type'],
    timezone: json['timezone'] == null ? undefined : json['timezone'],
  };
}

export function TargetToJSON(value?: Target | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    duty_status_reason: value['dutyStatusReason'],
    emails: value['emails'],
    group_details: value['groupDetails'],
    group_ids: value['groupIds'],
    id: value['id'],
    image_url: value['imageUrl'],
    key: value['key'],
    max_wrap_up_seconds: value['maxWrapUpSeconds'],
    name: value['name'],
    office_id: value['officeId'],
    on_duty_group_ids: value['onDutyGroupIds'],
    on_duty_status: value['onDutyStatus'],
    phones: value['phones'],
    ring_seconds: value['ringSeconds'],
    target_id: value['targetId'],
    target_type: value['targetType'],
    timezone: value['timezone'],
  };
}
